<template>
  <div
    class="bet-options">
    <div class="bet-options-buttons">
      <div class="button-container" v-for="bet in bets" :key="bet.bet">
        <div class="button-bet">
          <button-default
            buttonType="primary"
            :style="{background: colors.secondary}"
            height="105px"
            :textButton="`★ ${bet.bet.toLocaleString('pt-br')}`"
            :subTextButton="$t('components.betOption.desc-button') + `★ ${bet.win.toLocaleString('pt-br')}`"
            @eventButtonDefault="setBet(bet)"
          ></button-default>
        </div>
        <!-- <p class="desc-button">{{ $t("components.betOption.desc-button") }} ${{bet.win}}</p> -->
      </div>
    </div>
    <div class="bet-options-fotter">
      <span
      :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}"
        class="footer-desc"
      >{{$t("components.betOption.footer-desc")}}</span>
    </div>
  </div>
</template>
<script>
import ButtonDefault from "../buttons/ButtonDefault.vue";
export default {
  components: {
    ButtonDefault
  },
  data() {
    return {
      bets: [
        {
          bet: 2000,
          win: 4000
        },
        {
          bet: 5000,
          win: 10000
        },
        {
          bet: 7000,
          win: 14000
        },
        {
          bet: 10000,
          win: 20000
        }
      ],
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
  methods: {
    setBet(bet) {
      this.$emit("setBet", bet);
    }
  }
};
</script>
<style lang="scss" >
.bet-options {
  // height: 70%;

  .bet-options-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: .5rem 1rem;
    // height: 50%;
    max-width: 400px;
    margin: 0 auto;
    align-items: center;

    .button-container {
      // width: 40%;
      width: 150px;
      text-align: center;

      .desc-button {
        font-size: 8px;
        letter-spacing: 1px;
        margin-top: 10px;
        text-transform: uppercase;
      }
    }
  }

  .bet-options-fotter {
    // height: 15%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    font-size: 13px;
    // width: 90%;
    text-align: center;
    margin: 1rem auto;
    line-height: 1.5em;
    color: rgba(71, 71, 71, 0.52);
  }
  .button-default{
    font-weight: 900;
    letter-spacing: 0px;
    padding: 2rem 0;

    .subtext{
      padding-top: .5rem;
      // font-weight: 400;
      font-size: 14px;
    }
  }
}

@media only screen and (min-width: 370px) {
  .bet-options {
    .bet-options-buttons {
      .button-container {
        .desc-button {
          font-size: 9px;
        }
      }
    }

    .bet-options-fotter {
      font-size: 13px;
      width: 85%;
      margin: 2rem auto;
      text-align: center;
      font-weight: 700;
    }
  }
}

@media only screen and (min-width: 750px) {
  .bet-options {
    .bet-options-title {
      .title {
        font-size: 16px;
      }
    }

    .bet-options-buttons {
      // width: 70%;
      // height: 40%;
      margin: 0 auto;

      .button-container {
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // width: 50%;

        .button-bet {
          // width: 70%;
        }
      }
    }

    .bet-options-fotter {
      .footer-desc {
        font-size: 16px;
      }
    }
  }
}
@media only screen and (min-height: 790px) {
  .bet-options {
    .bet-options-title{
      .title{
        top: -72px;
      }
    }
  } 
}
@media only screen and (width: 412px) {
  .bet-options {
    .bet-options-title{
      .title{
        top: -55px;
      }
    }
  } 
}
</style>
